import React from "react";
import textTranslator from "../../../../utils/useTextTranslator";

const StatusBadge = ({ status, className = "", size = "md", Text, darkMode = false }) => {
	const getStatusClasses = () => {
		const baseClass = {
			sm: "px-2 py-0.5 text-xs",
			md: "px-3 py-1.5 text-sm",
			lg: "px-4 py-2 text-base",
		}[size || "md"];

		const statusLower = String(status || "").toLowerCase();

		if (
			statusLower.includes("schedule") ||
			statusLower.includes("pending")
		) {
			return darkMode
				? `${baseClass} bg-blue-500/10 text-blue-400 border border-blue-500/20 rounded-full font-medium`
				: `${baseClass} bg-blue-100 text-blue-800 border border-blue-200 rounded-full font-medium`;
		}
		if (statusLower.includes("confirm")) {
			return darkMode
				? `${baseClass} bg-amber-500/10 text-amber-400 border border-amber-500/20 rounded-full font-medium`
				: `${baseClass} bg-amber-100 text-amber-800 border border-amber-200 rounded-full font-medium`;
		}
		if (statusLower.includes("complete")) {
			return darkMode
				? `${baseClass} bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 rounded-full font-medium`
				: `${baseClass} bg-emerald-100 text-emerald-800 border border-emerald-200 rounded-full font-medium`;
		}
		if (statusLower.includes("cancel")) {
			return darkMode
				? `${baseClass} bg-rose-500/10 text-rose-400 border border-rose-500/20 rounded-full font-medium`
				: `${baseClass} bg-rose-100 text-rose-800 border border-rose-200 rounded-full font-medium`;
		}
		return darkMode
			? `${baseClass} bg-gray-500/10 text-gray-300 border border-gray-500/20 rounded-full font-medium`
			: `${baseClass} bg-gray-100 text-gray-800 border border-gray-200 rounded-full font-medium`;
	};

	return (
		<span className={`${getStatusClasses()} ${className}`.trim()}>
			{Text ? (
				<Text>{status || "-"}</Text>
			) : (
				textTranslator(status || "-", "APPOINTMENTS")
			)}
		</span>
	);
};

export default StatusBadge;
